import type { RouteHandle } from 'src/root';
import type { LoaderFunctionArgs } from 'react-router';
import type { ServerRendered } from 'src/server/catalog.server';

import { useLoaderData } from 'react-router';

import { isWideRequest } from 'src/utils/device';

import { Rentals } from 'src/screens/Rentals';
import { loadCatalog } from 'src/server/catalog.server';

import { ServerAnswers } from 'src/components/ServerAnswers';

export const handle: RouteHandle = { serverRendered: true };

/** The rent catalog, asked of the api by the server for the page it renders. */
export async function loader({ request, params }: LoaderFunctionArgs) {
  return loadCatalog({
    request,
    vertical: 'rent',
    makeSlug: params.make,
    modelSlug: params.model,
    wide: isWideRequest(request),
  });
}

/** Every later visit is the browser's own: the screen asks the api itself, as it always did. */
export const clientLoader = () => null;

export default function RentRoute() {
  const rendered = useLoaderData() as ServerRendered | null;

  return (
    <ServerAnswers rendered={rendered}>
      <Rentals />
    </ServerAnswers>
  );
}
